//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      model: null
    };
  },
  watch: {
    model: function model(val, oldVal) {
      if (!val) {
        this.$destroy();
      }
    }
  },
  methods: {
    $ready: function $ready() {
      this.model = true;
    },
    onClick: function onClick(spec, event) {
      this.model = false;
      Utils.type.ifFunction(spec.onClickFunction, function (f) {
        return f();
      });
      GLib.action.execute(spec.onClick, this);
    }
  }
};